/**
 * Closed list of body site codes accepted by the AIHS4 severity assessment
 * endpoint (see endpoint.md). Kept here as a union so the regions file and the
 * API hook stay in sync.
 */
export type AihsBodySiteCode =
  | 'headFront'
  | 'headBack'
  | 'headTop'
  | 'headLeft'
  | 'headRight'
  | 'armLeft'
  | 'armRight'
  | 'trunkFront'
  | 'trunkBack'
  | 'legLeft'
  | 'legRight'
  | 'handLeft'
  | 'handRight'
  | 'footLeft'
  | 'footRight'
  | 'genital'
  | 'nails'
  | 'scalp'
  | 'earLeft'
  | 'earRight'
  | 'perioral'
  | 'tongue'
  | 'elbowLeft'
  | 'elbowRight'
  | 'upperArmLeft'
  | 'upperArmRight'
  | 'lowerArmLeft'
  | 'lowerArmRight'
  | 'kneeLeft'
  | 'kneeRight'
  | 'upperLegLeft'
  | 'upperLegRight'
  | 'lowerLegLeft'
  | 'lowerLegRight';

export interface ProtocolRegion {
  id: string;
  number: number;
  bodySiteCode: AihsBodySiteCode;
}

/**
 * Region data for the Hidradenitis Suppurativa photography protocol.
 *
 * The user-facing region names, instructions and tips live in the
 * `shared/imageProtocol` translation namespace under `hs.regions.<id>.*`,
 * so consumers should look them up via `t()` rather than read them here.
 */
export const HS_PROTOCOL_REGIONS: ProtocolRegion[] = [
  {id: 'face', number: 1, bodySiteCode: 'headFront'},
  {id: 'neck', number: 2, bodySiteCode: 'trunkFront'},
  {id: 'left-axilla', number: 3, bodySiteCode: 'upperArmLeft'},
  {id: 'right-axilla', number: 4, bodySiteCode: 'upperArmRight'},
  {id: 'chest-inframammary', number: 5, bodySiteCode: 'trunkFront'},
  {id: 'abdomen', number: 6, bodySiteCode: 'trunkFront'},
  {id: 'back', number: 7, bodySiteCode: 'trunkBack'},
  {id: 'left-buttock', number: 8, bodySiteCode: 'trunkBack'},
  {id: 'right-buttock', number: 9, bodySiteCode: 'trunkBack'},
  {id: 'left-inguinal', number: 10, bodySiteCode: 'upperLegLeft'},
  {id: 'right-inguinal', number: 11, bodySiteCode: 'upperLegRight'},
  {id: 'genital', number: 12, bodySiteCode: 'genital'}
];
